









































































import { Component, Vue, Watch } from 'vue-property-decorator';
import FolderItemComponent from '@/main-components/folder/FolderItem.vue';
import FolderStore, {
  FolderStoreInterface,
} from '@/resource/folder/folder.store';
import { Folder } from '@/resource/folder/folder.model';
import getUrlByFolderArray from '@/utils/folder/get-url-by-folder-array';
import getFolderArrayByUrl from '@/utils/folder/get-folder-array-by-url';
import { FolderArray } from '@/utils/folder/get-folder-array-by-url';
import FolderItemStore, {
  FolderItemStoreInterface,
} from '@/resource/folder-item/folder-item.store';
import { FolderItem } from '@/resource/folder-item/folder-item.model';
import PreCollectionItem from '@/main-components/pre-collections-new/PreCollectionItem.vue';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import seoDefault from '@/utils/seo-default';

@Component({
  components: { FolderItemComponent, PreCollectionItem },
  metaInfo(this: FolderPage): MetaInfo {
    return {
      title: this.metaTitle,
      meta: [
        ...seoDefault({
          title: this.metaTitle + ' Mysoalan',
          description: this.metaDescription,
        }),
      ],
    };
  },
})
export default class FolderPage extends Vue {
  get metaTitle() {
    if (this.folder) {
      return this.folder.name + ' |';
    } else {
      return 'Koleksi |';
    }
  }

  get metaDescription() {
    if (this.folder) {
      return this.folder.description;
    } else {
      return 'Find all the popular exams & practice papers compiled here. The paper is a collection of questions for exam papers that is ready to be printed.';
    }
  }

  folderStore: FolderStoreInterface = FolderStore;
  folderItemStore: FolderItemStoreInterface = FolderItemStore;

  isFolderLoading = false;

  folders: Folder[] | null = null;
  folder: Folder | null = null;
  folderItems: FolderItem[] | null = null;

  paramsArray: FolderArray[] | null = null;

  // Only used when reloading to get the correct folder
  get folderUuid() {
    if (this.paramsArray) {
      return this.paramsArray[this.paramsArray.length - 1].uuid;
    } else {
      return null;
    }
  }
  // ---------------------------------------------------

  async created() {
    this.fetchParamsArray();

    // Only used when reloading to get the correct folder
    if (!this.folder && this.folderUuid) {
      this.isFolderLoading = true;

      await this.folderStore.fetchFolderByUuid(this.folderUuid);
      this.folder = this.folderStore.folder;

      this.isFolderLoading = false;
    }
    // ---------------------------------------------------

    this.fetchFolders();
  }

  async fetchFolders() {
    if (this.isFolderLoading) return;

    this.isFolderLoading = true;

    if (this.$route.params.uuid && this.folder) {
      await this.folderStore.fetchSubfolders(this.folder.id);
      this.folders = this.folderStore.folders;

      this.folderItems = null;
      await this.fetchFolderItems(this.folder.uuid);
    } else {
      this.folder = null;

      await this.folderStore.fetchRootFolders();
      this.folders = this.folderStore.folders;
      this.folderItems = null;
    }

    this.isFolderLoading = false;
  }

  async fetchPrevFolders() {
    if (this.isFolderLoading) return;
    this.isFolderLoading = true;

    if (this.paramsArray && this.paramsArray.length === 1) {
      this.folder = null;

      this.isFolderLoading = false;
      return this.$router.push({
        path: `/folders`,
      });
    }

    if (this.paramsArray && this.paramsArray.length > 1) {
      this.paramsArray.pop();
      await this.folderStore.fetchFolderByUuid(
        this.paramsArray[this.paramsArray.length - 1].uuid,
      );
      this.folder = this.folderStore.folder;
    }

    if (this.folder && this.paramsArray) {
      this.isFolderLoading = false;

      const updatedUrl = getUrlByFolderArray(this.paramsArray);

      this.$router.push({
        path: '/folders' + `/${updatedUrl}`,
      });
    }
  }

  async fetchFolderItems(folderUuid: string) {
    await this.folderItemStore.fetchFolderItems(folderUuid);
    this.folderItems = this.folderItemStore.folderItems;
  }

  fetchParamsArray() {
    this.paramsArray = this.$route.params.uuid
      ? getFolderArrayByUrl(this.$route.params.uuid)
      : null;
  }

  updateFolder(folder: Folder) {
    this.folder = folder;

    if (this.paramsArray) {
      this.paramsArray = [
        ...this.paramsArray,
        { name: this.folder.name, uuid: this.folder.uuid },
      ];
    } else {
      this.paramsArray = [{ name: this.folder.name, uuid: this.folder.uuid }];
    }

    const updatedUrl = getUrlByFolderArray(this.paramsArray);

    this.$router.push({
      path: '/folders' + `/${updatedUrl}`,
    });
  }

  async navigateToFolder(uuid: string) {
    if (this.isFolderLoading) return;

    this.isFolderLoading = true;

    if (this.paramsArray) {
      const index = this.paramsArray.findIndex(item => item.uuid === uuid);

      // Check if uuid was found and it's not the last item
      if (index !== -1 && index < this.paramsArray.length - 1) {
        this.paramsArray.splice(index + 1); // Remove all item after uuid that matched the search
      }
    }

    await this.folderStore.fetchFolderByUuid(uuid);
    this.folder = this.folderStore.folder;

    const updatedUrl = getUrlByFolderArray(this.paramsArray);

    this.isFolderLoading = false;

    this.$router.push({
      path: '/folders' + `/${updatedUrl}`,
    });
  }

  navigateToHome() {
    this.folder = null;
    this.$router.push({
      path: '/folders',
    });
  }

  @Watch('$route.params.uuid')
  onChangeUuid() {
    this.fetchParamsArray();
    this.fetchFolders();
  }
}
